/**
 * Portal 관리자 로그인 라우트 (/admin/login)
 * @description 이미 Admin 인증되어 있으면 /admin으로 리다이렉트
 */

import { createFileRoute, redirect } from '@tanstack/react-router';
import { config } from '@shared/config';
import { getAdminAuthStorage } from '@/utils/authStorage';
import { AdminLoginPage } from '@/features/auth/pages/AdminLoginPage';

export const Route = createFileRoute('/admin/login')({
  beforeLoad: async () => {
    const storage = getAdminAuthStorage();
    const storedUser = storage.getUser();
    const storedToken = storage.getToken();

    if (!storedUser || !storedToken) return;

    try {
      const response = await fetch(`${config.apiUrl}/api/portal/admin/auth/me`, {
        headers: { Authorization: `Bearer ${storedToken}` },
      }).catch(() => null);

      if (!response) {
        storage.clear();
        return;
      }
      if (response.ok) {
        throw redirect({ to: '/admin' });
      }
      storage.clear();
    } catch (error) {
      if (error && typeof error === 'object' && 'to' in error) throw error;
      storage.clear();
    }
  },
  component: AdminLoginPage,
});
